module.exports = {
	MASTER_THEMES: [
		{
			id: '0',
			title: 'Ressource en eau',
			comment: 'Thème ressource en eau',
			image: 'https://www.aquasys.fr/wp-content/uploads/2018/01/ressource-en-eau.jpg',
			color: '28, 189, 200'
		},
		{
			id: '1',
			title: 'Qualité des hydrosystèmes',
			comment: 'Gestion de Qualité des eaux',
			image: 'https://www.aquasys.fr/wp-content/uploads/2018/01/qualite-des-hydrosystemes.jpg',
			color: '17, 133, 138'
		},
		{
			id: '2',
			title: 'Pression',
			comment: 'Thème pression',
			image: 'http://www.aquasys.fr/wp-content/uploads/2017/10/Eau-potable.jpeg',
			color: '118, 135, 136'
		},
		{
			id: '3',
			title: 'Territoire',
			comment: 'Thème territoire',
			image: 'https://www.aquasys.fr/wp-content/uploads/2017/12/yulian.jpg',
			color: '68, 122, 60'
		}
	],
	THEMES: [
		{
			id: '0',
			title: 'Piézométrie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/piezo.jpg',
			color: '28, 189, 200',
			disable: false
		},
		{
			id: '1',
			title: 'Hydrométrie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydro.jpg',
			color: '44, 62, 109',
			disable: false
		},
		{
			id: '2',
			title: 'Météorologie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/meteo.jpg',
			color: '118, 135, 136',
			disable: false
		},
		{
			id: '5',
			title: 'Physico-chimie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/pc.jpg',
			color: '196, 22, 99',
			disable: false
		},
		{
			id: '4',
			title: 'Hydrobiologie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydrobio.jpg',
			color: '17, 133, 138',
			supports: ['4'],
			disable: false
		},
		{
			id: '3',
			title: 'Hydromorphologie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydromorpho.jpg',
			color: '18, 84, 153',
			disable: false
		},
		{
			id: '8',
			title: 'Services de l\'eau',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2017/10/Eau-potable.jpeg',
			color: '44, 62, 109',
			disable: false
		},
		{
			id: '7',
			title: 'Industrie',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/industrie.jpg',
			color: '118, 135, 136',
			disable: false
		},
		{
			id: '6',
			title: 'Agriculture',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/agri.jpg',
			color: '129, 168, 69',
			disable: true
		},
		{
			id: '10',
			title: 'Nature & Paysage',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/nature.jpg',
			color: '68, 122, 60',
			disable: true
		},
		{
			id: '11',
			title: 'Sol & Sous-sol',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/sols.jpg',
			color: '118, 135, 136',
			disable: false
		},
		{
			id: '9',
			title: 'Administration',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/admin.jpg',
			color: '12, 84, 153',
			disable: false
		}
	],
	LAYERS: [
		{
			id: '0',
			name: 'Zones sensibles aux remontées de nappes',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/risques?',
			layer: 'REMNAPPE_FIAB',
			visibility: false,
			themes: ['0'],
			source: 196608,
			zoom: '<= 5km',
			updateDate: 'Inconnu'
		},
		{
			id: '2',
			name: 'Entités hydrogéologiques affleurantes niveau 1',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV1',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '3',
			name: 'Entités hydrogéologiques affleurantes niveau 2',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV2',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<5km',
			updateDate: 'Inconnu'
		},
		{
			id: '4',
			name: 'Entités hydrogéologiques affleurantes niveau 3',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV3',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<2km',
			updateDate: 'Inconnu'
		},
		{
			id: '5',
			name: 'Plan d\'eau',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/eth_FXX?',
			layer: 'PlanEau',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '8',
			name: 'Hydroecorégions de niveau 2 (HER-2)',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/mdo_FXX?',
			layer: 'Hydroecoregion2',
			opacity: 1,
			visibility: false,
			themes: ['4'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '9',
			name: 'Tronçons élémentaires de masse d\'eau cours d\'eau - 2016',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/MasseDEau_VRAP2016?',
			layer: 'TronconElemMasseDEauRiviere_FXX',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '10',
			name: 'Aires d\'Alimentation de Captage (AAC)',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/aac_FRA?',
			layer: 'AiresAlimCaptage_FRA',
			opacity: 1,
			visibility: false,
			themes: ['8'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '11',
			name: 'Schémas d\'Aménagement et de Gestion des Eaux (SAGE) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'Sage',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '12',
			name: 'Contrats de milieu - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'ContratMilieu',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '13',
			name: 'Zones sensibles - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zs_FRA?',
			layer: 'ZoneSensibleFXX',
			opacity: 1,
			visibility: false,
			themes: [],
			source: 6,
			zoom: '<5km',
			updateDate: 'Inconnu'
		},
		{
			id: '14',
			name: 'Zones de répartition des eaux (ZRE) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'ZRE',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '15',
			name: 'Périmètre de Gestion Collective (PGC) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/PGC?',
			layer: 'PGC_FXX',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '16',
			name: 'Segments du Domaine Public Fluvial (DPF) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'SegDPF',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '21',
			name: 'Territoires à Risques d\'Inondation (TRI)',
			type: 'WMS',
			url: 'http://carto.sigloire.fr/cgi-bin/mapserv?',
			layer: 'n_tri_nant2014_inondable_s_044,n_tri_snaz2014_inondable_s_044,n_tri_aigu2014_carte_inond_s_085,n_tri_noir2015_inondable_s_085,n_tri_ange2013_carte_inond_s_049,n_tri_mans_inondable_s_072',
			opacity: 1,
			visibility: false,
			themes: [],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		},
		{
			id: '22',
			name: 'Cartes géologiques 1/50 000ième',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/geologie',
			layer: 'SCAN_D_GEOL50',
			opacity: 1,
			visibility: false,
			themes: ['11'],
			source: 196608,
			zoom: '<5km',
			updateDate: 'Inconnu'
		},
		{
			id: '23',
			name: 'Indice de Développement et de Persistance des Réseaux',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/geologie',
			layer: 'IDPR',
			opacity: 1,
			visibility: false,
			themes: ['0', '1'],
			source: 196608,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '24',
			name: 'Classification 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		},
		{
			id: '25',
			name: 'Classification 2016 20m',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:S2_2016_AllFeatures_20m',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		},
		{
			id: '26',
			name: 'Validité 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:PixelsValidity_ColorIndexed_S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		},
		{
			id: '27',
			name: 'Confiance 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:Confidence_ColorIndexed_S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		},
		{
			id: '28',
			name: 'Canalisations de transport de matières dangereuses : Gaz naturel',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_GAZ',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '29',
			name: 'Canalisations de transport de matières dangereuses : Hydrocarbures',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_HYDROCARBURES',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '30',
			name: 'Canalisations de transport de matières dangereuses : Produits chimiques',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_PRODUITS_CHIM',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '31',
			name: 'Masse d\'eau souterraine Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/mdo_FXX?',
			layer: 'MasseDEauSouterraine',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '33',
			name: 'Régions biogéographiques',
			type: 'WMS',
			url: 'http://ws.carmencarto.fr/WMS/119/fxx_ref?',
			layer: 'MNHN___INPN___Metropole',
			opacity: 1,
			visibility: false,
			themes: ['2'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '36',
			name: 'Réseau éléctrique',
			type: 'WMS',
			url: 'https://carto.atlasante.fr/cgi-bin/mapserv?',
			layer: 'MetropoleReseauelectriqueBDTop',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 163840,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '37',
			name: 'Territoires à Risques Importants d\'Inondation',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/203/communes_tri?',
			layer: 'Territoires_a_Risques_Importants_d_Inondation',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '38',
			name: 'Communes concernées par un PPR Inondation approuvé',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRN_COMMUNE_RISQINOND_APPROUV',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '39',
			name: 'Communes concernées par un PPR Risque industriel approuvé',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRT_COMMUNE_RISQIND_APPROUV',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '40',
			name: 'Communes concernées par un PPR technologiques',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRT_COMMUNE_GASPAR',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '41',
			name: 'Population communale dans l\'EAIP cours d\'eau',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'POP_EAIP_CE',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '42',
			name: 'Population communale dans l\'EAIP submersion marine',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'POP_EAIP_SM',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '43',
			name: 'Emprise totale des bâtiments dans l\'EAIP submersion marine (en m²)',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'BAT_TOT_EAIP_SM',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '44',
			name: 'Emprise totale des bâtiments dans l\'EAIP cours d\'eau (en m²)',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'BAT_TOT_EAIP_CE',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		},
		{
			id: '45',
			name: 'Hydrographie',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/sinistralite_inondation_test?',
			layer: 'Hydrographie',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 5km',
			updateDate: 'Inconnu'
		}
	],
	SITE_TYPES: [
		{
			type: 'INDUSTRIAL_SITE',
			themes: ['7'],
			source: 32771
		},
		{
			type: 'POLLUTED_SOIL',
			themes: ['7'],
			source: 32771
		},
		{
			type: 'QUALITOMETER',
			themes: ['5'],
			source: 1
		},
		{
			type: 'QUALITOMETER_SURFACE',
			themes: ['3', '4', '5'],
			source: 5
		},
		{
			type: 'PIEZOMETER',
			themes: ['0'],
			source: 1
		},
		{
			type: 'PIEZOMETER_REFERENCE',
			themes: ['0'],
			source: 1
		},
		{
			type: 'PLUVIOMETER',
			themes: ['2'],
			source: 7
		},
		{
			type: 'SEAPORT',
			themes: ['1'],
			source: 32776
		},
		{
			type: 'HYDROLOGICAL_STATION',
			themes: ['1'],
			source: 3
		},
		{
			type: 'TREATMENT_STATION',
			themes: ['8'],
			source: 6
		},
		{
			type: 'OBSTACLE_FLOW',
			themes: ['3'],
			source: 6
		},
		{
			type: 'HYDROLOGICAL_SITE',
			themes: ['1'],
			source: 3
		},
		{
			type: 'HYDROLOGICAL_INDICATOR',
			themes: ['1'],
			source: 3
		},
		{
			type: 'CITY',
			themes: ['8', '9'],
			source: 32774
		},
		{
			type: 'FISHING_PLACE',
			themes: ['4'],
			source: 65536
		},
		{
			type: 'CAVITY',
			themes: ['11'],
			source: 32771
		}
	],
	NEWS: [
		{
			id: 0,
			link: 'https://aquasys.fr/',
			title: 'Sécheresse record sur tout le territoire',
			content: 'Cet été 84 départements ont mis en œuvre des arrêtés de restriction des usages de l’eau !',
			status: 1,
			date: 1535118421954
		},
		{
			id: 1,
			link: 'https://aquasys.fr/',
			title: 'Confiance renouvelée par le BRGM',
			content: 'Le BRGM vient de prolonger de 4 ans notre prestation de gestion et maintenance de leur SIE',
			status: 1,
			date: 1425118421954
		}
	]
}



// WEBPACK FOOTER //
// ./src/administration/constants/MOCKConstants.js